import { Component, EventEmitter, HostBinding, Input, Output, OnInit } from '@angular/core';

export type ButtonState = 'initial' | 'loading' | 'success';

@Component({
  selector: 'app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.scss'],
})
export class AppLoaderComponent implements OnInit {

  @Input() loaderText?: string;

  @Input() iconSrc?: string;

  @Input() top: number = 50;

   @Input() color: number = 50;
  
  @Input() isActive: boolean = false;

  constructor() {}

  ngOnInit(): void {
    // if (this.isActive==true){
    this.setupFibonacciConcentric();
    // }
  }

    getGradientStyle(): { [key: string]: string } {
    if (this.color) {
            const gradient = `linear-gradient( 105deg,
        var(--ion-pass-${this.color}) 0%,
        var(--ion-pass-${this.color}) 50%,
        var(--ion-pass-${this.color}) 50%,
        var(--ion-shadeDark-${this.color}) 70%,
        var(--ion-color-${this.color}) 100%
      )`;
      return { 'background-image': gradient };
    }
    return {}; // Return empty object if no color is provided
  }
      genStyle(): { [key: string]: string } {
    if (this.color) {
      const color = `var(--ion-text-${this.color})`
      const top = `${this.top}%`;
      return { 'color': color , 'top':top};
    }
    return {}; // Return empty object if no color is provided
  }

  convertToPixels(value: string): number {
  if (value.endsWith('vh')) {
    const vh = parseFloat(value);
    return (vh / 100) * window.innerHeight;
  } else if (value.endsWith('vw')) {
    const vw = parseFloat(value);
    return (vw / 100) * window.innerWidth;
  } else {
    return parseFloat(value); // assume it's already in px
  }
}
	   setupFibonacciConcentric() {
  const container = document.getElementById("anim123");
  if (!container) {
    console.warn("SVG container #anim12 not found.");
    return;
  }

  container.innerHTML = ""; // clear previous content if any

  const N = 500;
  const SIZE = this.convertToPixels("40vw");
  const DOT_RADIUS = 1;
  const MARGIN = 0;
  const CENTER = SIZE / 2;
  const MAX_RADIUS = CENTER - MARGIN - DOT_RADIUS;
  const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5));
  const DURATION = 2;
  const svgNS = "http://www.w3.org/2000/svg";

  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", `${SIZE}`);
  svg.setAttribute("height", `${SIZE}`);
  svg.setAttribute("viewBox", `0 0 ${SIZE} ${SIZE}`);
  svg.setAttribute("xmlns", svgNS); // optional but good practice
  container.appendChild(svg);
const g = document.createElementNS(svgNS, "g");

// Group rotation animation
const groupAnim = document.createElementNS(svgNS, "animateTransform");
groupAnim.setAttribute("attributeName", "transform");
groupAnim.setAttribute("attributeType", "XML");
groupAnim.setAttribute("type", "rotate");
groupAnim.setAttribute("from", `0 ${CENTER} ${CENTER}`);
groupAnim.setAttribute("to", `-180 ${CENTER} ${CENTER}`);
groupAnim.setAttribute("dur", `${DURATION * 10}s`);
groupAnim.setAttribute("repeatCount", "indefinite");
groupAnim.setAttribute("calcMode", "spline");
groupAnim.setAttribute("keySplines", "0.42 0 0.58 1"); // ease-in-out
g.appendChild(groupAnim);

  for (let i = 0; i < N; i++) {
    const idx = i + 0.4;
    const frac = idx / N;
    const r = Math.sqrt(frac) * MAX_RADIUS;
    const theta = idx * GOLDEN_ANGLE;
    const x = CENTER - r * Math.cos(theta);
    const y = CENTER - r * Math.sin(theta);

// 	const k = 5;
// const r = MAX_RADIUS * Math.cos(k * theta);
// const x = CENTER + r * Math.sin(theta);
// const y = CENTER + r * Math.cos(theta);

// const R = 80; // outer radius
// const r = 35; // inner radius
// const d = 50; // pen distance from center
// const x = CENTER + (R - r) * Math.cos(theta) + d * Math.cos(((R - r) / r) * theta);
// const y = CENTER + (R - r) * Math.sin(theta) - d * Math.sin(((R - r) / r) * theta);

// const A = 60, B = 60, a = 3, b = 2, delta = Math.PI / 2;
// const x = CENTER + A * Math.sin(a * theta + delta);
// const y = CENTER + B * Math.sin(b * theta);

// const a = MAX_RADIUS;
// const r = a * Math.sqrt(Math.cos(2 * theta));
// const x = CENTER + r * Math.cos(theta);
// const y = CENTER + r * Math.sin(theta);


    const circle = document.createElementNS(svgNS, "circle");
    circle.setAttribute("cx", x.toFixed(2));
    circle.setAttribute("cy", y.toFixed(2));
    circle.setAttribute("r", DOT_RADIUS.toString());
    circle.setAttribute("fill", "var(--ion-white-primary)");
    circle.setAttribute("opacity", "0.3");

    // Radius animation
    const animR = document.createElementNS(svgNS, "animate");
    animR.setAttribute("attributeName", "r");
    animR.setAttribute("values", `${DOT_RADIUS * 0.5};${DOT_RADIUS * 2};${DOT_RADIUS * 0.5};`);
    animR.setAttribute("dur", `${DURATION}s`);
    animR.setAttribute("begin", `${(frac * DURATION).toFixed(2)}s`);
    animR.setAttribute("repeatCount", "indefinite");
    animR.setAttribute("calcMode", "spline");
    animR.setAttribute("keySplines", "0.65 0 0.35 1;1 0.35 0 0.65");

    // Opacity animation
    const animO = document.createElementNS(svgNS, "animate");
    animO.setAttribute("attributeName", "opacity");
    animO.setAttribute("values", "0.3;1;0.3");
    animO.setAttribute("dur", `${DURATION}s`);
    animO.setAttribute("begin", `${(frac * DURATION).toFixed(2)}s`);
    animO.setAttribute("repeatCount", "indefinite");
    animO.setAttribute("calcMode", "spline");
    animO.setAttribute("keySplines", "0.25 1 0.5 1;1 0.5 1 0.25");

    circle.appendChild(animR);
    circle.appendChild(animO);
    
	g.appendChild(circle);
	
  }
  svg.appendChild(g);
}

}